/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzureActivityLogAlertDetails {
    getFixupPrototypeFunction() { return AzureActivityLogAlertDetails.fixupPrototype; }

    static newInstance(model: Partial<AzureActivityLogAlertDetails>): AzureActivityLogAlertDetails {
        let obj = Object.assign(new AzureActivityLogAlertDetails(), model);
        AzureActivityLogAlertDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzureActivityLogAlertDetails>): AzureActivityLogAlertDetails {
        if (!model) return null;
        return AzureActivityLogAlertDetails.newInstance(<AzureActivityLogAlertDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzureActivityLogAlertDetails) {
        if (!obj) return;

        models.AzureActivityLogAlertDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzureActivityLogAlertDetails): boolean {
        Object.setPrototypeOf(obj, AzureActivityLogAlertDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Activity Log Alert Name
     */
    name: string;

    /**
     * Resource Group Name
     */
    resource_group: string;

    /**
     * Specifies whether the alert scope is subscription
     */
    is_subscription_scope: boolean;

}
